import i18n from 'utils/i18n'
import axiosClient from './axiosClient'
import urlApi from './url'
import whatYouNeedApi from './whatYouNeedApi'
const homeApi = {
  updateUser: (params, uid) => {
    return axiosClient.put(`${urlApi.user.user}/${uid}`, params);
  },
  verifyNumberPhone: (params) => {
    return axiosClient.get(`${urlApi.user.verifyPhone}`, { params });
  },
  getOTP: (params) => {
    return axiosClient.get(`${urlApi.user.getOTP}`, { params });
  },
  getWhatYouNeed: (params) => {
    return whatYouNeedApi.whatYouNeed(params);
  },
  getDashboard: (params) => {
    return axiosClient.get(`${urlApi.shared.getDashboard}`, { params });
  },

  getTagBombotStatistic: (params) => {
    return axiosClient.get(`${urlApi.dashboard.getTagBombotStatistic}`, {
      params
    });
  },

  getTagFacebookStatistic: (params) => {
    return axiosClient.get(`${urlApi.dashboard.getTagFacebookStatistic}`, {
      params
    });
  },

  getMessageStatistic: (params) => {
    return axiosClient.get(`${urlApi.dashboard.getMessageStatistic}`, {
      params
    });
  },

  getCampaignStatistic: (params) => {
    return axiosClient.get(`${urlApi.dashboard.getCampaignStatistic}`, {
      params
    });
  },

  getScenarioStatistic: (params) => {
    return axiosClient.get(`${urlApi.dashboard.getScenarioStatistic}`, {
      params
    });
  },

  getFanpageStatistic: (params) => {
    return axiosClient.get(`${urlApi.dashboard.getFanpageStatistic}`, {
      params
    });
  },

  getCustomerStatistic: (params) => {
    return axiosClient.get(`${urlApi.dashboard.getCustomerStatistic}`, {
      params
    });
  },

  getGenAIStatistic: (params) => {
    return axiosClient.get(`${urlApi.dashboard.getGenAIStatistic}`, {
      params
    });
  }
};

export default homeApi
